<template>
	<div class="login-bg flexc">
		<div class="login ">
			<div class="login-box">
				<div class="login-title ">
					<div style="font-size: 24px; font-weight: 500; text-align: center;">登录到</div>
					<div style="font-size: 48px; font-weight: 700; text-align: center; padding: 10px 0 20px 0;">惠邻鸟
					</div>
				</div>
			</div>
			<div class="login-input-box">
				<div class="login-input">
					<div>
						<el-input placeholder="请输入手机号" prefix-icon="el-icon-user" v-model="username"></el-input>
					</div>
					<div style="padding-top: 24px;">
						<el-input placeholder="请输入密码" prefix-icon="el-icon-lock" v-model="password"
							show-password></el-input>
					</div>
					<div class="flexb" style="padding-top: 24px;">
						<div style="font-size: 14px; color: #000;">
							<el-checkbox v-model="checked">记住账号</el-checkbox>
						</div>
					</div>
					<el-button class="login-btn" :loading="loading" :disabled="loading" @click="submitLogin">
						登录
					</el-button>
				</div>

			</div>

		</div>

	</div>
</template>

<script>
	import {
		loadRemembered
	} from '@/utils/remember';

	export default {
		created() {
			const remembered = loadRemembered();
			this.username = remembered.username || this.$store.state.auth.username || '';
			this.password = remembered.password || '';
			this.checked = remembered.remember;
		},
		data() {
			return {
				username: '',
				password: '',
				checked: false,
				loading: false
			}
		},
		methods: {
			async submitLogin() {
				if (this.loading) {
					return;
				}
				console.log('this.checked', this.checked)

				if (!this.username || !this.password) {
					this.$message.error('账号密码不能为空');
					return;
				}

				try {
					this.loading = true;
					await this.$store.dispatch('auth/login', {
						username: this.username,
						password: this.password,
						checked: this.checked
					})
					// 登录成功后的处理
					this.$message({
						message: '登录成功',
						type: 'success'
					});
					this.$router.push('/myShop');
				} catch (error) {
					console.log('error', error)
					// 这里可以在组件中使用 $message 提示错误
					this.$message.error((error && error.message) || '登录失败');
				} finally {
					this.loading = false;
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.login-bg {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-image: url('../../public/images/bg.png');
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;


		.login {

			padding-top: 40px;
			height: 507px;
			width: 870px;

			.login-box {
				display: flex;
				align-items: start;
				justify-content: center;

				.login-title {
					width: 161px;
					height: 145px;
				}
			}

			.login-input-box {
				display: flex;
				justify-content: center;
				align-items: center;
				padding-top: 40px;

				.login-input {

					height: 234px;
					width: 400px;
				}

				.login-btn {
					margin-top: 44px;
					height: 40px;
					width: 100%;
					background-color: #F79800;
					border-color: #F79800;
					color: #fff;
					border-radius: 3px;
				}

			}


		}


	}
</style>
